module.exports = __webpack_public_path__ + "img/frame-browser-foujita-es copy.34248f99.jpg";